import { LoadingButton } from "@mui/lab";
import { SxProps, Theme } from "@mui/material";
type Props = {
  fontSize?: number;
  width?: string;
  ButtonName: string;
  disabled: boolean;
  isSending: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  sx?: SxProps<Theme>;
  ariaLabel?: string;
};

const SendButton = (props: Props) => {
  return (
    <LoadingButton
      loading={props.isSending}
      sx={{
        fontSize: props.fontSize,
        mx: 2,
        width: props.width || "200px",
        fontFamily: "Public Sans",
        textTransform: "none",
        ...props.sx,
      }}
      aria-label={props.ariaLabel}
      variant="outlined"
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.ButtonName}
    </LoadingButton>
  );
};

export default SendButton;
